export const ENVIRONMENT = import.meta.env.VITE_ENV;
export const API_URL = import.meta.env.VITE_BACKEND_URL;
export const API_ID = import.meta.env.VITE_API_ID;
export const TENANT = import.meta.env.VITE_TENANT;
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const STOCK_PRICE_TTL = import.meta.env.VITE_STOCK_PRICE_TTL;
export const BASE_URL = import.meta.env.VITE_FRONTEND_URL;

export const CURRENT_YEAR = new Date().getFullYear();
export const HOUSEHOLD_GRID_TOO_MANY_RESULTS = 3;
export const HOUSEHOLD_GRID_MIN_SEARCH_LENGTH = 3;

export const TOAST_VERSION_KEY = "toastVersionKey";

export const UNIQUE_POSSIBILITIES = {
  MaxAge: 110,
  MinAge: 62,
  SocialSecurityAgeList: Array.from({ length: 110 - 62 + 1 }, (_, i) => i + 62),
};
export const MINIMAL_BACKEND_VERSION = "0.3.0";

export const IS_PRODUCTION =
  typeof window !== "undefined" && ENVIRONMENT?.toLocaleLowerCase() === "prod";

// expected config env to include "heroku"
export const IS_HEROKU =
  typeof window !== "undefined" && ENVIRONMENT?.toLocaleLowerCase().includes("heroku");

export const SUPPORT_EMAIL = "support@think1st.pro";
